import SitecoreTextModel from '@models/SitecoreTextModel';

const TEXT_ARR = [
  'Captured On Text',
  'Description',
  'No Data Text',
  'Section Title',
  'View All Button Text',
  'Captured On Text',
  'Purchase On The Spot Label'
];

const LINK_ARR = ['Link'];

export default class CustomerInterestPageModel {
  constructor() {
    TEXT_ARR.forEach((item) => {
      this[item] = new SitecoreTextModel();
    });
  }

  getData(dataSource) {
    TEXT_ARR.forEach((item) => {
      if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, item)) {
        this[item] = dataSource[item] ?? this[item];
      }
    });

    LINK_ARR.forEach((item) => {
      if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, item)) {
        this[item] = dataSource[item] ?? this[item];
      }
    });

    return this;
  }
}